module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_1.b9a14b52.png";